import { useThumbnailForSegment } from '../hooks/useThumbnailForSegment';
import {
  generateFallbackThumbnailDisplayInfo,
  getThumbnailFrameIndexFromOffsetSeconds,
  resolveThumbnailMetadata,
} from '../utils';
import { LoadingThumbnail } from './LoadingThumbnail';
import { PreloadedThumbnail } from './PreloadedThumbnail';

interface Props {
  stationId: string;
  segmentId: number;
  offsetSeconds?: number;
  animated?: boolean;
  theme?: 'dark' | 'light';
  targetHeight?: number;
}

export function SegmentThumbnail({
  stationId,
  segmentId,
  animated,
  offsetSeconds = 0,
  theme = 'light',
  targetHeight,
}: Props) {
  const thumb = useThumbnailForSegment(stationId, segmentId);

  // Only show loader if we don't have any thumbnail data (initial load)
  // When segmentId changes, placeholderData keeps the previous thumbnail visible
  if (thumb.isLoading && !thumb.info) {
    return (
      <LoadingThumbnail
        metadata={generateFallbackThumbnailDisplayInfo()}
        theme={theme}
        targetHeight={targetHeight}
      />
    );
  }

  if (!thumb.info) {
    return null;
  }

  const metadata = resolveThumbnailMetadata([thumb.info.metadata]);

  return (
    <PreloadedThumbnail
      url={thumb.info.thumbnailUrl}
      metadata={metadata}
      offset={getThumbnailFrameIndexFromOffsetSeconds(offsetSeconds, metadata)}
      animated={animated}
      theme={theme}
      targetHeight={targetHeight}
    />
  );
}
